import { useDispatch, useSelector } from "react-redux";
import Checkers from "../../../../../../helpers/class/Checkers";
import LgConsts from "../../../../../../helpers/LgConsts";
import { enableBookingBtn, fetchBuilderSettingByKey } from "../../../../../../helpers/MethodHelper";
import { generateBookUrlHandler, generateIquiryUrlHandler } from "../../../../../../helpers/HandlerHelper";
import { updateBookingFormTriggered } from "../../../../../../redux/actions";

export default function BookingInquireChainButtons(props) {

  const dispatch = useDispatch()

  const showIquires = useSelector(
    state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_bookings_inquires_allow')
  );

  const propertyInitialAvailability = useSelector(state => state['propertyAvailability']['initialAvailability'])
  const inquiriesOnly = useSelector(state => state['appSettings']['inquiriesOnly'])

  const bedroomPricing = useSelector(state => state['appSettings']['bedroomPricing'])

  const priceLoading = useSelector(state => state['appSettings']['priceLoading'])
  const adults = useSelector(state => state['propertiesParams']['adults'])
  const kids = useSelector(state => state['propertiesParams']['kids'])
  const infants = useSelector(state => state['propertiesParams']['infants'])

  const dateRangeValid = useSelector(state => state['propertiesParams']['dateRangeValid'])

  const personsForBooking = (adults + kids + infants)

  const inquiryUrl = generateIquiryUrlHandler()

  const bookUrl = generateBookUrlHandler()

  const enableButtons = enableBookingBtn(propertyInitialAvailability, priceLoading, personsForBooking, dateRangeValid)

  const bookingType = useSelector(state => state['appSettings']['bookingType'])

  let builder_booking_box_class = 'col-12 col-sm-8 col-md-6 col-lg-12 ms-auto me-auto ms-lg-0 me-lg-0';

  let builder_booking_box_border = false;
  let builder_booking_box_shadow = false;
  let builder_booking_box_radius = 0;

  const hasPrice = props.price

  let white_class = 'bg-master-lightest';
  if (!builder_booking_box_border && !builder_booking_box_shadow && builder_booking_box_radius === 0) {
    white_class = 'bg-white';
  }

  const modifyRoomParam = (url, newRoomValue) => {
    const urlObj = new URL(url);
    urlObj.searchParams.set("room", newRoomValue);
    return urlObj.toString();
  };

  return (
    <div className={builder_booking_box_class}>
      <div className="row">
        {
          (inquiriesOnly == '1' || showIquires == '1' || bookingType == LgConsts.BOOKING_TYPE_1_INQUIRIES) ?
            <div className={"col"} onClick={() => {
              dispatch(updateBookingFormTriggered(true))
            }}>
              <a className={"btn btn-lg btn-default btn-black full-width btn-bordered " + (hasPrice ? '' : 'disabled')}
                target="_blank" rel="noreferrer" href={inquiryUrl}>Inquire</a>
            </div>
            :
            ""
        }
        {
          inquiriesOnly != '1' && Checkers.isValidString(bookUrl) && (bookingType == LgConsts.BOOKING_TYPE_2_WEBHOTELIER || (propertyInitialAvailability && bookingType == LgConsts.BOOKING_TYPE_1_INQUIRIES)) ?
            <div onClick={() => {
              dispatch(updateBookingFormTriggered(true))
            }} className={"col"}>
              <a className={"btn btn-lg btn-primary btn-design-color full-width " + (hasPrice ? '' : 'disabled')}
                target="_blank" rel="noreferrer" href={modifyRoomParam(bookUrl, `${props.whRoomCode}`)}>Book now</a>
            </div>
            :
            <></>
        }
      </div>
    </div>
  )
}